import { Skeleton } from '@/ui/skeleton';

export function MapLiveWeatherSkeleton() {
	return (
		<div className="container size-full sm:container">
			<Skeleton className="z-[999] h-96 w-full overflow-hidden rounded-2xl bg-black/50 fade-in-50 sm:absolute sm:right-0 sm:top-0 sm:mr-4 sm:mt-4 sm:max-w-fit" />
		</div>
	);
}
